import { Info, Mic } from "lucide-react";
import MobileHeader from "components/mobile-header";
import NotificationBar from "components/notification-bar";
import SelectAudioDevice from "sections/audio-check/select-audio-device";
import MicTest from "sections/audio-check/mic-test";

const AudioCheck = () => {
  return (
    <div className="w-full px-4 md:px-6 lg:px-6 pb-8">
      <MobileHeader />

      {/* Dashboard top bar */}
      <div className="flex items-center justify-between border-b border-solid border-brand-header-border mb-6 mt-2 lg:mt-0 pb-4 lg:pb-2.5">
        <h2 className="text-lg md:text-xl font-semibold mt-4 lg:mt-0">Audio Check</h2>
        <NotificationBar />
      </div>

      {/* Centered card — matches onboarding-audio-check styling */}
      <div className="max-w-[440px] mx-auto">
        <div className="bg-white rounded-xl shadow-auth-card p-6 md:p-7">

          {/* Header */}
          <div className="flex items-center gap-3 mb-5">
            <div className="w-9 h-9 rounded-full bg-primary flex items-center justify-center shrink-0">
              <Mic size={16} strokeWidth={2} className="text-gray-800" />
            </div>
            <div>
              <h2 className="text-base font-semibold text-gray-900 leading-tight">
                Audio Setup
              </h2>
              <p className="text-xs text-gray-400 mt-0.5">
                Quick check before your first session
              </p>
            </div>
          </div>

          {/* Browser permission note */}
          <div className="flex items-start gap-2 bg-blue-50 border border-blue-100 rounded-lg px-3 py-2.5 mb-5">
            <Info size={14} className="text-blue-500 mt-0.5 shrink-0" />
            <p className="text-[12px] text-blue-700 leading-snug">
              Your browser will ask to access your microphone — click{" "}
              <strong>Allow</strong>. On Safari or Edge, you may also need to
              enable it under browser settings.
            </p>
          </div>

          {/* Step 1 — Devices */}
          <div className="mb-5">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-5 h-5 rounded-full bg-gray-900 text-white text-[10px] font-bold flex items-center justify-center shrink-0">
                1
              </span>
              <h3 className="text-sm font-semibold text-gray-800">
                Select your audio devices
              </h3>
            </div>
            <SelectAudioDevice compact />
          </div>

          <div className="border-t border-gray-100 mb-5" />

          {/* Step 2 — Mic test */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-5 h-5 rounded-full bg-gray-900 text-white text-[10px] font-bold flex items-center justify-center shrink-0">
                2
              </span>
              <h3 className="text-sm font-semibold text-gray-800">
                Test your microphone
              </h3>
            </div>
            <MicTest />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AudioCheck;
